













import Vue from 'vue'
import Header from '@/components/Header.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import Footer from '@/components/Footer.vue'
import { mapState } from 'vuex'

export default Vue.extend({
  components: {
    Header,
    CookieBanner,
    Footer
  },
  data() {
    return {
      registration: (null as ServiceWorkerRegistration | null),
      updateExists: false,
      refreshing: false
    }
  },
  created() {
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      // Reload the page to pick up the newly installed version
      window.location.reload()
    })
  },
  computed: {
    ...mapState('sampler', [
      'samplerLoaded'
    ]),
    loading(): boolean {
      return !this.samplerLoaded
    }
  },
  methods: {
    updateAvailable(event: Event) {
      this.registration = (event as CustomEvent<ServiceWorkerRegistration>).detail
      this.updateExists = true

      this.$buefy.snackbar.open({
        duration: 5000,
        message: 'An update has been installed. Press update to use the new version',
        actionText: 'Update',
        onAction: () => {
          this.refreshApp()
        }
      })
    },
    refreshApp() {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
})
